import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Dropdown, message, Modal} from "antd";
import {createCopyLinkByLibraryItem, getImagePathWithTheme, isDarkMode} from "../../utils";
import {t} from "i18next";
import {getCardById, updateCard} from "@model/card";
import {EVENT_REFRESH_LIBRARY_LIST, EVENT_REFRESH_PDF_ANNO_COMMENT, usedColorToShowColor} from "@/Const";
import {ipcInvoke, ipcOn, ipcRemove, ipcRemoveThisAll} from "@/common/ipc";
import {postMessage} from "@/common/event";
import {dbGetHighlight} from "@model/highlight";
import {createLibraryItemMenu} from "@/MenuUtils";
import {openEditor} from "@/state";
import global from "@/global";
import {copyTextToSystemClipboard} from "../../../@excalidraw/packages/excalidraw/clipboard";

const DialogPdfAnno = forwardRef((props:{onClose:any}, ref)=>{
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [pdfAnnoData,setPdfAnnoData] = useState<any>(null);
    const [arrayMenu,setArrayMenu] = useState([]);

    const txtInputRef = useRef(null);
    const mPdfAnnoDataRef = useRef(null);

    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const updatePdfAnnoComment = async (msg,data)=>{
        for (let j=0;j<data.annotations.length;j++) {
            const anno = data.annotations[j];
            if (anno.id == pdfAnnoData?.id) {
                setPdfAnnoData({...pdfAnnoData,comment:anno.comment})
                break;
            }
        }
    }

    useEffect(() => {
        ipcOn('pdf-note-update-1',updatePdfAnnoComment)

        return ()=>{
            ipcRemoveThisAll('pdf-note-update-1')
        }
    },);

    useEffect(() => {
        global.g_showDialogs.dialogPdfAnno = true;
        return ()=>{
            window.globalRefreshList('refresh_single_library_item_',mPdfAnnoDataRef.current?.id);
            global.g_showDialogs.dialogPdfAnno = false;
        }
    }, []);

    useEffect(() => {
        mPdfAnnoDataRef.current = pdfAnnoData;
    }, [pdfAnnoData]);

    const onShowDialog = (libraryData:any)=>{
        setIsShowDialog(true);
        setPdfAnnoData(libraryData);
        setArrayMenu(createLibraryItemMenu('',false,libraryData))
    }

    const handleMenuClick = async (event:any)=>{
        const szAction = event.key;
        const item = pdfAnnoData;
        if (szAction == 'locateHighlight'){
            locationSource();
        }else if (szAction == 'changeSource'){
            changeSourceEvent(item);
        }else if (szAction == 'showInfo'){
            window.showInfo('library',item);
        }else if (szAction == 'copyLink'){
            createCopyLinkByLibraryItem(item);
        }else if (szAction == 'managerTags'){
            //管理标签
            window.showManageTags([item]);
        }else if (szAction == 'addToProject'){
            //添加到project.
            window.showDialogChooseProject([item]);
        }else if (szAction == 'delete'){
            //删除，关闭
            const newPdfAnno = {...pdfAnnoData};
            newPdfAnno.isDeleted = 1;
            setPdfAnnoData(newPdfAnno);
            setIsShowDialog(false);//关闭的时候自动更新
        }else if (szAction == 'copyHighlightText'){
            let szNote = '';
            if (pdfAnnoData.comment){
                szNote = '\n' + t("Note")+":"+pdfAnnoData.comment
            }
            copyTextToSystemClipboard(pdfAnnoData.text + szNote);
        }
    }

    /**
     * 定位到.
     */
    const locationSource = ()=>{
        setIsShowDialog(false);
        if (pdfAnnoData.type == 'cardAnno'){
            openEditor(pdfAnnoData.libraryId,true,false,'','card',pdfAnnoData.id);
        }else{
            ipcInvoke('save-one-annotations',{data:{pdfId:pdfAnnoData.libraryId,id:pdfAnnoData.id,comment:pdfAnnoData.comment}}).then(async (res)=>{
                const library:any = await getCardById(pdfAnnoData.libraryId);
                if (library) {
                    window.showPdfPreview(library.name,library.id,library.fileName,false,true,true,{highlightId:pdfAnnoData.id});
                }else {
                    message.error(t("Open error"))
                }

                setTimeout(()=>{
                    closeThis();
                },200)
            })
        }
    }

    /**
     * 更改source
     */
    const changeSourceEvent = (item:any)=>{
        //选择的
        const arrayChecked:any = [];
        if (item){
            arrayChecked.push(item);
        }
        ipcInvoke('getFilePath',{filters:[{ name: 'Pdf', extensions: ['pdf']}]}).then(async (res)=>{
            if (res){
                for (let i=0;i<arrayChecked.length;i++){
                    let item = arrayChecked[i];
                    if (item.type == 'video' || item.type == 'pdf' || item.type == 'videoAnno' || item.type == 'pdfAnno'){
                        if (item.type == 'pdfAnno' || item.type == 'videoAnno'){
                            item = await getCardById(item.libraryId);
                        }
                        if (item.type == 'pdf' || item.type == 'video'){
                            item.isAbsolutePath = true;
                            item.fileName = res;
                            await updateCard(item);
                            //这里重新加载pdf?????。。。。。这里不用重新加载...

                        }
                    }
                }
            }
        })
    }

    /**
     * 关闭
     */
    const closeThis=()=>{
        if (props.onClose) {
            props.onClose();
        }
    }

    /**
     * 保存到数据库等....
     */
    const updateToDb = async ()=>{
        return new Promise(resolve => {
            //保存到数据库
            updateCard({...pdfAnnoData}).then(async (res)=>{
                if (pdfAnnoData.type == 'cardAnno'){
                    //更新到html内部注记
                    await window.onUpdateComment(pdfAnnoData,()=>{

                    });
                    // postMessage(EVENT_REFRESH_LIBRARY_LIST);
                    window.globalRefreshList('refresh_single_library_item_',mPdfAnnoDataRef.current?.id);
                }else if (pdfAnnoData.type == 'pdfAnno'){
                    postMessage(EVENT_REFRESH_PDF_ANNO_COMMENT,{annotations:[pdfAnnoData],fileId:pdfAnnoData.libraryId})
                    //更新这一个注记内容
                    await ipcInvoke('save-one-annotations',{data:{pdfId:pdfAnnoData.libraryId,id:pdfAnnoData.id,comment:pdfAnnoData.comment}});
                }

                //刷新tableview中的.
                window.globalRefreshList('refresh_tableview_single_data_',pdfAnnoData.id);

                resolve('ok');
            })
        })
    }

    return(
        <Modal width={680} bodyStyle={{height:'600px',fontSize:'12px'}} open={isShowDialog} centered={true}
               afterClose={()=>{
                   updateToDb();
                   if (props.onClose) {
                       props.onClose();
                   }
               }}
               closable={false} closeIcon={<IconClose/>} footer={null}
               onCancel={()=>setIsShowDialog(false)}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <img className={'img-26 mr-4'} style={{marginTop: '-2.5px'}}
                         src={getImagePathWithTheme('dialog_highlight')}/>
                    <span className={'dialog-title span-single-line mr-16'}>{pdfAnnoData?.name || t("Untitled")}</span>
                    <div style={{flexGrow: '1'}}/>
                    <img className={'img-26 cursor-pointer'} style={{}}
                         src={getImagePathWithTheme('dialog_anno_location')}
                         onClick={async () => {
                             updateToDb().then(res=>{
                                 locationSource();
                             })
                         }}/>
                    <img className={'img-26 cursor-pointer ml-6'} src={getImagePathWithTheme('dialog_anno_info')}
                         onClick={() => {
                             window.showInfo('library', pdfAnnoData);
                         }}/>
                    <Dropdown overlayClassName='default-dropdown-style'
                              menu={{items: arrayMenu, onClick: handleMenuClick}}
                              trigger={['click']}>
                        <img className={'img-26 ml-6 cursor-pointer'}  style={{marginRight:'-10px'}}
                             src={getImagePathWithTheme('dialog_anno_more')}/>
                    </Dropdown>

                </div>

                {
                    pdfAnnoData &&
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontSize: '12px',
                            paddingLeft: '6px',
                            paddingRight: '6px',
                            paddingBottom: '6px',
                            height: '100%',
                            marginTop:'12px',
                            overflow: 'hidden',
                        }}>
                        {/*<div style={{display: 'flex', alignItems: 'center', flexShrink: '0px'}}><span*/}
                        {/*    style={{*/}
                        {/*        color: pdfAnnoData.color,*/}
                        {/*        border: `1px solid ${pdfAnnoData.color}`,*/}
                        {/*        width: '18px',*/}
                        {/*        height: '18px',*/}
                        {/*        display: 'flex',*/}
                        {/*        justifyItems: 'center',*/}
                        {/*        justifyContent: 'center',*/}
                        {/*        flexShrink: '0',*/}
                        {/*        minHeight: '18px',*/}
                        {/*    }}>A</span><span*/}
                        {/*    style={{*/}
                        {/*        marginLeft: '4px',*/}
                        {/*        color: pdfAnnoData.color,*/}
                        {/*        textOverflow: 'ellipsis',*/}
                        {/*        whiteSpace: 'nowrap',*/}
                        {/*        overflow: 'hidden'*/}
                        {/*    }}>{"" + pdfAnnoData.name}</span>*/}
                        {/*</div>*/}
                        {/*<div*/}
                        {/*    style={{*/}
                        {/*        height: '1px',*/}
                        {/*        background: '#E4E4E4',*/}
                        {/*        marginTop: '6px',*/}
                        {/*        marginLeft: '-16px',*/}
                        {/*        marginRight: '-16px'*/}
                        {/*    }}></div>*/}
                        {
                            pdfAnnoData.annoType == "highlight" &&
                            <div>
                                <blockquote
                                    style={{
                                        marginTop: '10px',
                                        marginLeft: '0px',
                                        marginRight: '0px',
                                        paddingLeft: '8px',
                                        borderLeft: `2px solid ${usedColorToShowColor(pdfAnnoData.color)}`,
                                        textAlign: 'left',
                                    }}>
                                  <span className={'default-font-family'} style={{
                                      color: isDarkMode() ? 'var(--text-color)' : 'var(--text-color)',
                                      marginTop: '4px',
                                      fontSize:'13px'//视觉问题，看着小，实际跟library中是一样的12px 调整为13
                                  }}>{pdfAnnoData.text}</span>
                                </blockquote>

                            </div>

                        }
                        {
                            pdfAnnoData.annoType == 'image' &&
                            <div style={{maxHeight:'80%',overflow:'hidden',textAlign:'center'}}>
                                <img src={pdfAnnoData.thumbImage} style={{
                                    width: (pdfAnnoData?.width > pdfAnnoData?.height)?'100%':'auto',
                                    height: (pdfAnnoData?.width > pdfAnnoData?.height)?'auto':'100%',
                                }}/>
                            </div>
                        }
                        <textarea ref={txtInputRef} placeholder={t("Add a note")} style={{
                            marginTop: '14px', resize: 'none',
                            fontSize:'13px',
                            background: 'transparent',
                            flexGrow:'1',
                            flexShrink:'0',
                            color:'var(--text-color)',
                            minHeight:pdfAnnoData.comment?'160px':'0px',
                            outline: 'none', border: 'none'
                        }} onChange={(e)=>{
                            var newData = {...pdfAnnoData};
                            newData.comment = e.currentTarget.value;
                            setPdfAnnoData(newData);
                        }} value={pdfAnnoData?.comment}></textarea>
                    </div>
                }
            </div>
        </Modal>
    )
})

export default DialogPdfAnno;